import React, { useState, useEffect } from 'react';
import { collection, doc, onSnapshot, updateDoc, addDoc, deleteDoc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../servicios/firebase';
import ModalSeguridad from '../../components/ui/ModalSeguridad';
import BotonVolver from '../../components/ui/BotonVolver';

const Horarios = () => {
  const [rutas, setRutas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [zonasCargadas, setZonasCargadas] = useState({});

  // ESTADOS CREACIÓN
  const [creandoRuta, setCreandoRuta] = useState(false);
  const [nuevaRutaOrigen, setNuevaRutaOrigen] = useState("");
  const [nuevaRutaDestino, setNuevaRutaDestino] = useState("");
  const [diasOperacion, setDiasOperacion] = useState([0,1,2,3,4,5,6]);
  const [horasTemporales, setHorasTemporales] = useState([]);
  const [horaTempInput, setHoraTempInput] = useState("");

  // ESTADOS EDICIÓN
  const [editandoRutaId, setEditandoRutaId] = useState(null);
  const [editOrigen, setEditOrigen] = useState("");
  const [editDestino, setEditDestino] = useState("");
  const [editDias, setEditDias] = useState([]);
  const [editHoras, setEditHoras] = useState([]);
  const [editHoraInput, setEditHoraInput] = useState("");

  // ESTADOS GESTIÓN
  const [modalOpen, setModalOpen] = useState(false);
  const [accionPendiente, setAccionPendiente] = useState(null);

  // ── ESTADOS EXCEPCIONES ──────────────────────────────────────────────────
  const [excepciones, setExcepciones] = useState([]);
  const [creandoExcepcion, setCreandoExcepcion] = useState(false);
  const [excRutaId, setExcRutaId] = useState('');
  const [excFecha, setExcFecha] = useState('');
  const [excHorariosBase, setExcHorariosBase] = useState([]);
  const [excEliminados, setExcEliminados] = useState([]);
  const [excExtra, setExcExtra] = useState([]);
  const [excHoraInput, setExcHoraInput] = useState('');
  const [excNota, setExcNota] = useState('');

  const diasSemana = [
    { id: 1, label: 'Lunes' }, { id: 2, label: 'Martes' }, { id: 3, label: 'Miércoles' },
    { id: 4, label: 'Jueves' }, { id: 5, label: 'Viernes' }, { id: 6, label: 'Sábado' }, { id: 0, label: 'Domingo' }
  ];

  // ── CARGA INICIAL ────────────────────────────────────────────────────────
  useEffect(() => {
    const unsubRutas = onSnapshot(collection(db, 'rutas'), (snap) => {
      setRutas(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setLoading(false);
    });

    // Listener de excepciones en tiempo real
    const unsubExc = onSnapshot(collection(db, 'excepciones'), (snap) => {
      setExcepciones(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });

    const cargarTerm = async () => {
      try {
        const snap = await getDoc(doc(db, 'configuraciones', 'terminales'));
        if (snap.exists()) setZonasCargadas(snap.data());
      } catch (e) { console.error("Error BD:", e); }
    };
    cargarTerm();

    return () => { unsubRutas(); unsubExc(); };
  }, []);

  // ── RUTAS — CREAR ────────────────────────────────────────────────────────
  const guardarNuevaRuta = async (e) => {
    e.preventDefault();
    if (!nuevaRutaOrigen || !nuevaRutaDestino) return alert("Faltan datos");
    if (nuevaRutaOrigen === nuevaRutaDestino) return alert("Origen y destino iguales");
    try {
      await addDoc(collection(db, 'rutas'), {
        origen: nuevaRutaOrigen,
        destino: nuevaRutaDestino,
        activo: true,
        horariosSalida: horasTemporales,
        diasOperacion: diasOperacion
      });
      setCreandoRuta(false);
      setNuevaRutaOrigen(""); setNuevaRutaDestino("");
      setDiasOperacion([0,1,2,3,4,5,6]); setHorasTemporales([]);
    } catch (e) { alert("Error al guardar"); }
  };

  // ── RUTAS — EDITAR ───────────────────────────────────────────────────────
  const iniciarEdicion = (ruta) => {
    setEditandoRutaId(ruta.id);
    setEditOrigen(ruta.origen);
    setEditDestino(ruta.destino);
    setEditDias(ruta.diasOperacion || []);
    setEditHoras(ruta.horariosSalida || []);
    setEditHoraInput("");
  };

  const guardarEdicion = async () => {
    if (!editandoRutaId) return;
    try {
      await updateDoc(doc(db, 'rutas', editandoRutaId), {
        origen: editOrigen,
        destino: editDestino,
        diasOperacion: editDias,
        horariosSalida: editHoras
      });
      setEditandoRutaId(null);
      alert("✅ Ruta actualizada");
    } catch (error) {
      console.error(error);
      alert("Error al actualizar");
    }
  };

  const toggleDiaEdicion = (id) => {
    if (editDias.includes(id)) setEditDias(editDias.filter(d => d !== id));
    else setEditDias([...editDias, id]);
  };

  const agregarHoraEdicion = () => {
    if (!editHoraInput) return;
    if (!editHoras.includes(editHoraInput)) setEditHoras([...editHoras, editHoraInput].sort());
    setEditHoraInput("");
  };

  const quitarHoraEdicion = (hora) => setEditHoras(editHoras.filter(h => h !== hora));

  // ── EXCEPCIONES — GUARDAR ────────────────────────────────────────────────
  const guardarExcepcion = async () => {
    if (!excRutaId || !excFecha) return alert('Selecciona ruta y fecha');
    if (excEliminados.length === 0 && excExtra.length === 0)
      return alert('No hay cambios — agrega o cancela al menos un horario');

    // El ID del doc es fecha_rutaId → si guardas dos veces el mismo día, sobreescribe sin duplicar
    const docId = `${excFecha}_${excRutaId}`;
    try {
      await setDoc(doc(db, 'excepciones', docId), {
        fecha: excFecha,
        rutaId: excRutaId,
        horariosEliminados: excEliminados,
        horariosExtra: excExtra,
        nota: excNota,
        creadoEn: new Date().toISOString(),
      });
      // Reset formulario
      setCreandoExcepcion(false);
      setExcRutaId(''); setExcFecha('');
      setExcEliminados([]); setExcExtra([]);
      setExcNota(''); setExcHoraInput('');
      setExcHorariosBase([]);
    } catch (e) {
      alert('Error al guardar: ' + e.message);
    }
  };

  // ── COMPONENTES AUXILIARES ───────────────────────────────────────────────
  const SelectorTerminales = ({ val, setVal }) => (
    <select required className="w-full p-2 border rounded-lg bg-gray-50 font-bold text-gray-700 text-sm" value={val} onChange={e => setVal(e.target.value)}>
      <option value="">-- Selecciona --</option>
      {Object.entries(zonasCargadas).map(([nombreZona, listaTerminales]) => {
        if (Array.isArray(listaTerminales)) {
          return (
            <optgroup key={nombreZona} label={nombreZona}>
              {listaTerminales.map((term, i) => (
                <option key={i} value={term}>{term}</option>
              ))}
            </optgroup>
          );
        }
        return null;
      })}
    </select>
  );

  const agregarHoraTemporal = () => {
    if (!horaTempInput) return;
    if (!horasTemporales.includes(horaTempInput)) setHorasTemporales([...horasTemporales, horaTempInput].sort());
    setHoraTempInput("");
  };

  const toggleDiaCreacion = (id) => {
    if (diasOperacion.includes(id)) setDiasOperacion(diasOperacion.filter(d => d !== id));
    else setDiasOperacion([...diasOperacion, id]);
  };

  // ── RENDER ───────────────────────────────────────────────────────────────
  return (
    <div className="p-6 max-w-6xl mx-auto min-h-screen bg-gray-50 pb-20">

      {/* HEADER */}
      <div className="mb-8 bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-wrap justify-between items-center gap-4">
        <div><h1 className="text-3xl font-bold text-gray-800">Logística de Rutas</h1></div>
        <div className="flex gap-3">
          <button onClick={() => setCreandoRuta(!creandoRuta)} className="px-5 py-2.5 rounded-xl font-bold bg-blue-600 text-white hover:bg-blue-700">
            {creandoRuta ? 'Cancelar' : '＋ Nueva Ruta'}
          </button>
          <BotonVolver />
        </div>
      </div>

      {/* FORMULARIO CREACIÓN */}
      {creandoRuta && (
        <div className="bg-white border-2 border-blue-100 p-8 rounded-2xl mb-8 shadow-xl">
          <h3 className="text-xl font-bold text-gray-800 mb-6">✨ Crear Nueva Ruta</h3>
          <form onSubmit={guardarNuevaRuta} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div><label className="text-xs font-bold text-gray-500 block mb-1">Origen</label><SelectorTerminales val={nuevaRutaOrigen} setVal={setNuevaRutaOrigen} /></div>
              <div><label className="text-xs font-bold text-gray-500 block mb-1">Destino</label><SelectorTerminales val={nuevaRutaDestino} setVal={setNuevaRutaDestino} /></div>
            </div>
            <div>
              <label className="text-xs font-bold text-gray-500 block mb-2">Días de Operación</label>
              <div className="flex flex-wrap gap-2">
                {diasSemana.map(d => (
                  <button type="button" key={d.id} onClick={() => toggleDiaCreacion(d.id)}
                    className={`px-3 py-2 rounded-lg text-sm font-bold border ${diasOperacion.includes(d.id) ? 'bg-blue-600 text-white' : 'bg-white'}`}>
                    {d.label.substring(0, 3)}
                  </button>
                ))}
              </div>
            </div>
            <div className="bg-blue-50 p-4 rounded-xl border border-blue-100">
              <label className="text-xs font-bold text-blue-700 block mb-2">Horarios de Salida</label>
              <div className="flex gap-2 mb-2">
                <input type="time" value={horaTempInput} onChange={e => setHoraTempInput(e.target.value)} className="p-2 border rounded-lg" />
                <button type="button" onClick={agregarHoraTemporal} className="bg-blue-600 text-white px-4 rounded-lg font-bold">Agregar</button>
              </div>
              <div className="flex flex-wrap gap-2">
                {horasTemporales.map(h => (
                  <div key={h} className="bg-white px-3 py-1 rounded-full border border-blue-200 text-blue-800 font-bold flex gap-2">
                    {h} <button type="button" onClick={() => setHorasTemporales(horasTemporales.filter(x => x !== h))} className="text-red-400">✕</button>
                  </div>
                ))}
              </div>
            </div>
            <button type="submit" className="w-full bg-black text-white py-4 rounded-xl font-bold shadow-lg">Guardar Ruta</button>
          </form>
        </div>
      )}

      {/* LISTADO DE RUTAS */}
      <div className="grid grid-cols-1 gap-6">
        {rutas.map(r => (
          <div key={r.id} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-200 transition hover:shadow-md">
            {editandoRutaId === r.id ? (
              <div className="animate-fadeIn">
                <div className="flex justify-between items-center mb-4 pb-2 border-b">
                  <h3 className="font-bold text-blue-600">✏️ Editando Ruta</h3>
                  <button onClick={() => setEditandoRutaId(null)} className="text-gray-400 hover:text-gray-600">Cancelar</button>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  <div><label className="text-xs font-bold text-gray-400">Origen</label><SelectorTerminales val={editOrigen} setVal={setEditOrigen} /></div>
                  <div><label className="text-xs font-bold text-gray-400">Destino</label><SelectorTerminales val={editDestino} setVal={setEditDestino} /></div>
                </div>
                <div className="mb-4">
                  <label className="text-xs font-bold text-gray-400 block mb-1">Días</label>
                  <div className="flex flex-wrap gap-1">
                    {diasSemana.map(d => (
                      <button key={d.id} onClick={() => toggleDiaEdicion(d.id)}
                        className={`px-2 py-1 rounded text-xs font-bold border ${editDias.includes(d.id) ? 'bg-blue-600 text-white' : 'bg-gray-100'}`}>
                        {d.label.substring(0, 3)}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="mb-4 bg-gray-50 p-3 rounded-lg">
                  <label className="text-xs font-bold text-gray-400 block mb-1">Horarios</label>
                  <div className="flex gap-2 mb-2">
                    <input type="time" value={editHoraInput} onChange={e => setEditHoraInput(e.target.value)} className="p-1 border rounded text-sm" />
                    <button onClick={agregarHoraEdicion} className="bg-blue-600 text-white px-3 text-xs rounded font-bold">＋</button>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {editHoras.map(h => (
                      <span key={h} className="bg-white px-2 py-1 rounded border text-xs font-bold flex items-center gap-1">
                        {h} <button onClick={() => quitarHoraEdicion(h)} className="text-red-500 font-bold ml-1">×</button>
                      </span>
                    ))}
                  </div>
                </div>
                <button onClick={guardarEdicion} className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-2 rounded-lg">
                  Guardar Cambios
                </button>
              </div>
            ) : (
              <>
                <div className="flex justify-between items-start mb-4">
                  <div>
                    <h2 className="text-xl font-bold text-gray-800 flex items-center gap-2">
                      {r.origen} <span className="text-gray-400 text-sm">➝</span> {r.destino}
                    </h2>
                    <div className="flex gap-1 mt-2">
                      {diasSemana.map(d => (
                        <span key={d.id} className={`text-[10px] px-1.5 py-0.5 rounded ${r.diasOperacion?.includes(d.id) ? 'bg-blue-100 text-blue-700 font-bold' : 'text-gray-300'}`}>
                          {d.label.substring(0, 1)}
                        </span>
                      ))}
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <button onClick={() => iniciarEdicion(r)} className="text-blue-500 bg-blue-50 hover:bg-blue-100 p-2 rounded-lg transition">✏️</button>
                    <button onClick={() => { setAccionPendiente({ tipo: 'ELIMINAR_RUTA', rutaId: r.id }); setModalOpen(true); }} className="text-red-500 bg-red-50 hover:bg-red-100 p-2 rounded-lg transition">🗑️</button>
                  </div>
                </div>
                <div className="border-t pt-4">
                  <p className="text-xs font-bold text-gray-400 uppercase mb-2">Horarios de Salida (base — todos los días)</p>
                  <div className="flex flex-wrap gap-2">
                    {r.horariosSalida && r.horariosSalida.length > 0 ? r.horariosSalida.map(h => (
                      <span key={h} className="bg-gray-100 px-3 py-1 rounded-lg text-sm font-bold text-gray-700 border border-gray-200">{h}</span>
                    )) : <span className="text-gray-400 text-sm italic">Sin horarios asignados</span>}
                  </div>
                </div>
              </>
            )}
          </div>
        ))}
        {rutas.length === 0 && !loading && <p className="text-center text-gray-400 py-10">No hay rutas configuradas.</p>}
      </div>

      {/* ══════════════════════════════════════════════
          SECCIÓN EXCEPCIONES POR FECHA
          El admin modifica esto. El cliente ve los
          resultados automáticamente al buscar.
      ══════════════════════════════════════════════ */}
      <div className="mt-12">
        <div className="mb-6 bg-white p-6 rounded-2xl shadow-sm border border-orange-100 flex flex-wrap justify-between items-center gap-4">
          <div>
            <h2 className="text-2xl font-bold text-gray-800">📅 Excepciones por Fecha</h2>
            <p className="text-sm text-gray-500 mt-1">
              Modifica horarios solo para un día específico. Los horarios base de la ruta <strong>no se tocan</strong>.
            </p>
          </div>
          <button
            onClick={() => setCreandoExcepcion(!creandoExcepcion)}
            className="px-5 py-2.5 rounded-xl font-bold bg-orange-500 text-white hover:bg-orange-600"
          >
            {creandoExcepcion ? 'Cancelar' : '＋ Nueva Excepción'}
          </button>
        </div>

        {/* FORMULARIO NUEVA EXCEPCIÓN */}
        {creandoExcepcion && (
          <div className="bg-white border-2 border-orange-100 p-8 rounded-2xl mb-8 shadow-xl">
            <h3 className="text-lg font-bold text-gray-800 mb-6">✨ Crear Excepción de Horario</h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="text-xs font-bold text-gray-500 block mb-1">Ruta</label>
                <select
                  className="w-full p-2 border rounded-lg bg-gray-50 font-bold text-gray-700 text-sm"
                  value={excRutaId}
                  onChange={e => {
                    setExcRutaId(e.target.value);
                    const ruta = rutas.find(r => r.id === e.target.value);
                    setExcHorariosBase(ruta?.horariosSalida || []);
                    setExcEliminados([]);
                    setExcExtra([]);
                  }}
                >
                  <option value="">-- Selecciona ruta --</option>
                  {rutas.map(r => (
                    <option key={r.id} value={r.id}>{r.origen} ➝ {r.destino}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="text-xs font-bold text-gray-500 block mb-1">Fecha afectada</label>
                <input
                  type="date"
                  className="w-full p-2 border rounded-lg bg-gray-50 font-bold text-gray-700 text-sm"
                  value={excFecha}
                  onChange={e => setExcFecha(e.target.value)}
                />
              </div>
            </div>

            {excRutaId && excFecha && (
              <>
                {/* CANCELAR HORARIOS BASE */}
                <div className="mb-6">
                  <label className="text-xs font-bold text-red-500 uppercase block mb-2">
                    ❌ Horarios base — toca para cancelar ese día
                  </label>
                  <p className="text-xs text-gray-400 mb-3">Los tachados NO aparecerán para el cliente ese día. Los demás días siguen igual.</p>
                  <div className="flex flex-wrap gap-2">
                    {excHorariosBase.length > 0 ? excHorariosBase.map(h => (
                      <button
                        key={h}
                        type="button"
                        onClick={() => {
                          if (excEliminados.includes(h)) setExcEliminados(excEliminados.filter(x => x !== h));
                          else setExcEliminados([...excEliminados, h]);
                        }}
                        className={`px-4 py-2 rounded-lg font-bold border-2 transition-all text-sm ${
                          excEliminados.includes(h)
                            ? 'bg-red-100 border-red-400 text-red-600 line-through'
                            : 'bg-white border-gray-200 text-gray-700 hover:border-red-300'
                        }`}
                      >
                        {h}
                      </button>
                    )) : (
                      <span className="text-gray-400 text-sm italic">Esta ruta no tiene horarios base aún</span>
                    )}
                  </div>
                </div>

                {/* AGREGAR HORARIOS EXTRA */}
                <div className="mb-6 bg-green-50 p-4 rounded-xl border border-green-100">
                  <label className="text-xs font-bold text-green-700 uppercase block mb-1">
                    ➕ Horarios extra solo ese día
                  </label>
                  <p className="text-xs text-gray-400 mb-3">El cliente verá estos horarios adicionales únicamente ese día.</p>
                  <div className="flex gap-2 mb-3">
                    <input
                      type="time"
                      value={excHoraInput}
                      onChange={e => setExcHoraInput(e.target.value)}
                      className="p-2 border rounded-lg text-sm"
                    />
                    <button
                      type="button"
                      onClick={() => {
                        if (!excHoraInput) return;
                        if (!excExtra.includes(excHoraInput)) setExcExtra([...excExtra, excHoraInput].sort());
                        setExcHoraInput('');
                      }}
                      className="bg-green-600 text-white px-4 rounded-lg font-bold text-sm"
                    >
                      Agregar
                    </button>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {excExtra.map(h => (
                      <span key={h} className="bg-white px-3 py-1 rounded-full border border-green-300 text-green-800 font-bold text-sm flex items-center gap-2">
                        {h}
                        <button onClick={() => setExcExtra(excExtra.filter(x => x !== h))} className="text-red-400 font-bold">✕</button>
                      </span>
                    ))}
                  </div>
                </div>

                {/* NOTA OPCIONAL */}
                <div className="mb-6">
                  <label className="text-xs font-bold text-gray-500 block mb-1">Nota interna (opcional)</label>
                  <input
                    type="text"
                    placeholder="Ej: Semana Santa, día festivo, unidad en taller..."
                    className="w-full p-2 border rounded-lg text-sm"
                    value={excNota}
                    onChange={e => setExcNota(e.target.value)}
                  />
                </div>

                {/* PREVIEW — lo que verá el cliente */}
                <div className="mb-6 p-4 bg-blue-50 rounded-xl border border-blue-100">
                  <p className="text-xs font-bold text-blue-700 mb-3">👁 Lo que verá el cliente si busca en esa fecha:</p>
                  <div className="flex flex-wrap gap-2">
                    {[...excHorariosBase.filter(h => !excEliminados.includes(h)), ...excExtra]
                      .sort()
                      .map(h => (
                        <span key={h} className={`px-3 py-1 rounded-lg font-bold text-sm ${
                          excExtra.includes(h)
                            ? 'bg-green-100 text-green-700 border border-green-300'
                            : 'bg-white text-gray-700 border'
                        }`}>
                          {h}{excExtra.includes(h) ? ' ✦' : ''}
                        </span>
                      ))}
                    {[...excHorariosBase.filter(h => !excEliminados.includes(h)), ...excExtra].length === 0 && (
                      <span className="text-red-500 text-sm font-bold">⚠️ Sin ningún horario ese día</span>
                    )}
                  </div>
                  {excExtra.length > 0 && <p className="text-[10px] text-green-600 mt-2">✦ = horario extra</p>}
                </div>

                <button
                  onClick={guardarExcepcion}
                  className="w-full bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 rounded-xl transition-colors"
                >
                  💾 Guardar Excepción
                </button>
              </>
            )}
          </div>
        )}

        {/* LISTA DE EXCEPCIONES GUARDADAS */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {excepciones.length === 0 ? (
            <p className="text-gray-400 italic text-sm col-span-2 text-center py-8">
              No hay excepciones registradas. Los horarios base aplican todos los días.
            </p>
          ) : (
            excepciones
              .sort((a, b) => a.fecha.localeCompare(b.fecha))
              .map(exc => {
                const ruta = rutas.find(r => r.id === exc.rutaId);
                const horariosFinales = [
                  ...(ruta?.horariosSalida || []).filter(h => !(exc.horariosEliminados || []).includes(h)),
                  ...(exc.horariosExtra || [])
                ].sort();
                return (
                  <div key={exc.id} className="bg-white p-5 rounded-xl shadow-sm border border-orange-100 hover:shadow-md transition">
                    <div className="flex justify-between items-start mb-3">
                      <div>
                        <span className="text-lg font-black text-orange-600">{exc.fecha}</span>
                        <p className="text-sm font-bold text-gray-700 mt-0.5">
                          {ruta ? `${ruta.origen} ➝ ${ruta.destino}` : exc.rutaId}
                        </p>
                        {exc.nota && <p className="text-xs text-gray-400 mt-1 italic">📝 {exc.nota}</p>}
                      </div>
                      <button
                        onClick={() => { setAccionPendiente({ tipo: 'ELIMINAR_EXCEPCION', excId: exc.id }); setModalOpen(true); }}
                        className="text-red-400 hover:text-red-600 bg-red-50 hover:bg-red-100 p-2 rounded-lg transition"
                      >
                        🗑️
                      </button>
                    </div>

                    {(exc.horariosEliminados?.length > 0 || exc.horariosExtra?.length > 0) && (
                      <div className="space-y-1.5 mb-3">
                        {exc.horariosEliminados?.length > 0 && (
                          <div className="flex flex-wrap gap-1 items-center">
                            <span className="text-[10px] font-bold text-red-500 uppercase">Cancelados:</span>
                            {exc.horariosEliminados.map(h => (
                              <span key={h} className="text-xs bg-red-50 text-red-500 px-2 py-0.5 rounded line-through font-bold">{h}</span>
                            ))}
                          </div>
                        )}
                        {exc.horariosExtra?.length > 0 && (
                          <div className="flex flex-wrap gap-1 items-center">
                            <span className="text-[10px] font-bold text-green-600 uppercase">Extra:</span>
                            {exc.horariosExtra.map(h => (
                              <span key={h} className="text-xs bg-green-50 text-green-600 px-2 py-0.5 rounded font-bold">{h}</span>
                            ))}
                          </div>
                        )}
                      </div>
                    )}

                    <div>
                      <p className="text-[10px] font-bold text-gray-400 uppercase mb-1">Cliente verá ese día:</p>
                      <div className="flex flex-wrap gap-1">
                        {horariosFinales.length > 0 ? horariosFinales.map(h => (
                          <span key={h} className={`text-xs px-2 py-0.5 rounded font-bold ${
                            exc.horariosExtra?.includes(h) ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'
                          }`}>{h}</span>
                        )) : (
                          <span className="text-xs text-red-500 font-bold">Sin servicio ese día</span>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })
          )}
        </div>
      </div>

      {/* MODAL SEGURIDAD — maneja tanto rutas como excepciones */}
      <ModalSeguridad
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={async () => {
          if (accionPendiente?.tipo === 'ELIMINAR_RUTA') {
            await deleteDoc(doc(db, 'rutas', accionPendiente.rutaId));
            setModalOpen(false);
          }
          if (accionPendiente?.tipo === 'ELIMINAR_EXCEPCION') {
            await deleteDoc(doc(db, 'excepciones', accionPendiente.excId));
            setModalOpen(false);
          }
        }}
        title={accionPendiente?.tipo === 'ELIMINAR_EXCEPCION' ? 'Eliminar Excepción' : 'Eliminar Ruta'}
        message={
          accionPendiente?.tipo === 'ELIMINAR_EXCEPCION'
            ? 'Se elimina la excepción y ese día vuelve a los horarios base normales.'
            : '¿Seguro que deseas borrar esta ruta permanentemente?'
        }
        actionType="danger"
      />
    </div>
  );
};

export default Horarios;